module.exports = __webpack_public_path__ + "static/media/cancel-red.395f19a5.png";